import { ReactComponent as SettingsSvg } from '../../blocks/LandingPage2/assets/phase2/Setting.svg';
import SvgIcon from '@material-ui/core/SvgIcon';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

export const SettingSvg = () => {
  <SvgIcon>
    <SettingsSvg />
  </SvgIcon>;
};
